/**
 * Mirrors `src/lib/customerEnvironmentSlugs.js` for comparing API `environment_type` (DB canonical)
 * with UI keys (`dev`, `prod`, etc.). Update both when adding environments.
 */

const SLUGS = new Set(["development", "qa", "uat", "production"]);

const LEGACY = { dev: "development", prod: "production" };

const SSM_UPPER = { DEV: "development", QA: "qa", UAT: "uat", PROD: "production" };

/**
 * @param {unknown} environment
 * @returns {string | null}
 */
export function toCanonicalEnvironmentTypeSlug(environment) {
  if (environment == null) return null;
  const raw = String(environment).trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(LEGACY, lower)) return LEGACY[lower];
  if (SLUGS.has(lower)) return lower;
  const upper = raw.toUpperCase();
  if (Object.prototype.hasOwnProperty.call(SSM_UPPER, upper)) return SSM_UPPER[upper];
  return null;
}

/**
 * @param {unknown} a
 * @param {unknown} b
 * @returns {boolean}
 */
export function isSameEnvironmentType(a, b) {
  const ca = toCanonicalEnvironmentTypeSlug(a);
  const cb = toCanonicalEnvironmentTypeSlug(b);
  if (ca && cb) return ca === cb;
  return false;
}
